// extracted by mini-css-extract-plugin
export var inlineImage = "schema-inline-image-module--inlineImage--516e5";